// src/store/index.js
import { createStore } from 'vuex';
import api from '@/api'; // ⬅️ usa la instancia con interceptores

export default createStore({
  state: {},
  mutations: {},
  actions: {
    // --- ACTIVO ---
    getUnique(_, uuid) {
      return api.get(`/activo/unique/${uuid}`)
        .then((r) => r.data);
    },
    getMainImage(_, uuid) {
      // devuelve ArrayBuffer/bytes -> en tu componente haces el base64
      return api.get(`/activo/main-image-resource/${uuid}`, { responseType: 'arraybuffer' })
        .then((r) => r.data);
    },
    getCategory(_, uuid) {
      return api.get(`/activo/category/${uuid}`)
        .then((r) => r.data);
    },
    getAddress(_, uuid) {
      return api.get(`/activo/address/${uuid}`)
        .then((r) => r.data);
    },
    generateGenericQR(_, cantidad) {
      return api.post('/activo/create-generic', { cantidad })
        .then((r) => r.data);
    },
    getIdRecurso(_, uuid) {
      return api.get(`/activo/id-recurso/${uuid}`)
        .then((r) => r.data);
    },
    getActivoQR(_, idRecurso) {
      return api.get(`/recurso/qr/${idRecurso}`, {
        responseType: 'arraybuffer', // <<--- clave
      })
        .then((r) => r.data); // te devuelve un ArrayBuffer
    },
    getLastActive() {
      return api.get('/activo/last-active')
        .then((r) => r.data);
    },
    createActive(_, data) {
      return api.post('/activo/create', data)
        .then((r) => r.data);
    },
    updateActive(_, data) {
      // si tu backend espera /activo/update o /activo/update/:uuid ajusta aquí:
      return api.put('/activo/update', data)
        .then((r) => r.data);
    },

    // --- RECURSOS / UPLOADS ---
    addMainImageActive(_, { uuid, file }) {
      const formData = new FormData();
      formData.append('file', file);
      return api.post(`/recurso/add-main-image-asset/${uuid}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then((r) => r.data);
    },
    addFileAsset(_, { uuid, files }) {
      const formData = new FormData();
      files.forEach((f) => formData.append('file', f));
      return api.post(`/recurso/add-file-asset/${uuid}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then((r) => r.data);
    },

    // --- CATÁLOGOS ---
    getSububications() {
      return api.get('/sububicacion')
        .then((r) => r.data.map((item) => ({
          text: item.nombre,
          value: item.id_sububicacion,
        })));
    },
    getAllCategories() {
      return api.get('/categoria-activo')
        .then((r) => r.data.map((item) => ({
          text: item.categoria,
          value: item.id_categoria_activo,
        })));
    },
    getAllClients() {
      return api.get('/cliente')
        .then((r) => r.data.map((item) => ({
          text: item.razon_social,
          value: item.id_cliente,
        })));
    },
  },
});
